import { render, staticRenderFns } from "./MonitorScoreExams.vue?vue&type=template&id=3f49f4ba&"
import script from "./MonitorScoreExams.vue?vue&type=script&lang=js&"
export * from "./MonitorScoreExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports